// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2XYj-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__Sa1Ex"};